import React, { useEffect, useState, useLayoutEffect, useRef } from "react";
import { discoverData } from "../../StaticData/DiscoverData";
import { DiscoverCard } from "../../components/DiscoverCard/DiscoverCard";
import "./DiscoverList.scss";
import axiosInstance from "../../config/axios-instance";
import special from "../../img/special.png";
import SpecialCollection from "../../img/SpecialCollection.jpg";
/* import seasons from "../../img/seasons.png"; */
import axios from "axios";
import { DiscoverItem } from "../DiscoverCard/DiscoverItem";
import { useSelector } from "react-redux";
/* import Garments from "../../img/garmentV2.jpg";
import knit_garment from "../../img/garmentV2.jpg";
import knit_special_collections from "../../img/collection2.jpg";
import seasons from "../../img/session2.jpg"; */
/* import Garments from "../../img/Garments.jpg";
import knit_garment from "../../img/knit_garments.jpg";
import knit_special_collections from "../../img/knit_special_collections.jpg"; */

import Garments from "../../img/gam_1.webp";
import knit_garment from "../../img/gam_1.webp";
import knit_special_collections from "../../img/col_1.webp";
import seasons from "../../img/ses_1.webp";
import { Skeleton } from "antd";
import gsap from "gsap";

interface Props {}

export const DiscoverList = (props: Props) => {
  const [width, setWidth] = useState(window.innerWidth);
  const [specialCollectionsRes, setSpecialCollectionsRes] = useState<any>(null);
  const [seasonCollectionRes, setSeasonCollectionRes] = useState<any>(null);
  const [collectionRes, setCollectionRes] = useState<any>(null);
  const [responsibleChoices, setResponsibleChoicesRes] = useState<any>(null);

  const [menObj, setMenObj] = useState<any>({});
  const [womenObj, setWomenObj] = useState<any>({});
  const [unisexObj, setUnisexObj] = useState<any>({});
  const [garmentsRes, setGarmentsRes] = useState<any>(null);
  const { user, isAdmin } = useSelector((state: any) => state.auth);

  let specialCollections = "/collections/56";
  let seasonCollection = "/collections/25";
  let collections = "/collections/home/published";

  let garments = `/categories?gender=${
    user && !isAdmin && user.genders && user.genders.length !== 0
      ? user.genders.find((el: any) => el.id === 1)
        ? "1"
        : user.genders[0].id
      : "1"
  }&fabric_type=${
    user && !isAdmin && user.fabric_type === "knit" ? "knit" : "denim"
  }`;

  let responsible_choices = `/filters/reponsible?fabric_type=${
    user && !isAdmin && user.fabric_type === "knit" ? "both" : "denim"
  }`;
  console.log(garments);
  const uniqByKeepLast = (a: any, key: any) => {
    return [...new Map(a.map((x: any) => [key(x), x])).values()];
  };
  React.useEffect(() => {
    const specialCollectionsReq = axiosInstance({
      method: "get",
      url: specialCollections,
    });

    const seasonCollectionReq = axiosInstance({
      method: "get",
      url: seasonCollection,
    });
    const garmentsReq = axiosInstance({
      method: "get",
      url: garments,
    });
    const collectionsReq = axiosInstance({
      method: "get",
      url: collections,
    });
    const responsibleChoicesReq = axiosInstance({
      method: "get",
      url: responsible_choices,
    });
    axios
      .all([
        specialCollectionsReq,
        seasonCollectionReq,
        garmentsReq,
        collectionsReq,
        responsibleChoicesReq,
      ])
      .then(
        axios.spread((...responses) => {
          setSpecialCollectionsRes(responses[0].data);
          setSeasonCollectionRes(responses[1].data);
          setGarmentsRes(uniqByKeepLast(responses[2].data, (k: any) => k.name));
          setCollectionRes(responses[3].data);
          setResponsibleChoicesRes(responses[4].data.our_responsible_choice);
        })
      )

      .catch((errors) => {});
  }, []);

  React.useEffect(() => {
    if (user && !isAdmin && user.genders.length !== 0) {
      setMenObj(
        user && !isAdmin && user.genders.find((el: any) => el.name === "Men")
      );
      setWomenObj(
        user && !isAdmin && user.genders.find((el: any) => el.name === "Women")
      );
      setUnisexObj(
        user && !isAdmin && user.genders.find((el: any) => el.name === "Unisex")
      );
    } else {
      setMenObj({
        id: 1,
        name: "Men",
      });
    }
  }, []);
  const [sectionContent, setSectionContent] = useState<any>(null);

  const getsectionContent = () => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/home/section2`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res: any) => {
      setSectionContent(res.data);
    });
  };

  useEffect(() => {
    getsectionContent();
  }, []);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  // --- Premium Accordion & 3D Tilt Logic ---
  const containerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
      if (width < 768) return; // Disable GSAP accordion on mobile

      // 1. Accordion Standard Setup (Manual cleanup since v3.7.1)
      const items = gsap.utils.toArray(".accordion-item");
      const cleanupListeners: (() => void)[] = [];
      
      // Initial State: Equal width
      gsap.set(items, { flexGrow: 1, filter: "grayscale(0%) brightness(100%)" });

      items.forEach((item: any) => {
        // Expand on Hover
        const onEnter = () => {
          gsap.to(items, { flexGrow: 1, duration: 0.4, ease: "power2.out", overwrite: "auto" }); // Reset others
          gsap.to(item, { flexGrow: 5, duration: 0.6, ease: "cubic.out", overwrite: "auto" }); // Expand target
          // Dim others
          const others = items.filter(x => x !== item);
          gsap.to(others, { filter: "grayscale(80%) brightness(70%)", duration: 0.4, overwrite: "auto" });
          gsap.to(item, { filter: "grayscale(0%) brightness(100%)", duration: 0.4, overwrite: "auto" });
        };
        
        // 3D Tilt Effect
        const onMove = (e: MouseEvent) => {
           const rect = item.getBoundingClientRect();
           const x = e.clientX - rect.left;
           const y = e.clientY - rect.top;
           
           // Calculate rotation (range: -5 to 5 deg)
           const xPct = (x / rect.width - 0.5) * 2; // -1 to 1
           const yPct = (y / rect.height - 0.5) * 2; // -1 to 1
           
           gsap.to(item, {
             rotationY: xPct * 5,
             rotationX: -yPct * 5,
             transformPerspective: 1000,
             ease: "power1.out",
             duration: 0.2,
             overwrite: "auto"
           });
        };
        
        const onLeave = () => {
           // Reset tilt
           gsap.to(item, { rotationY: 0, rotationX: 0, ease: "power2.out", duration: 0.5 });
        };

        item.addEventListener("mouseenter", onEnter);
        item.addEventListener("mousemove", onMove);
        item.addEventListener("mouseleave", onLeave);

        cleanupListeners.push(() => {
            item.removeEventListener("mouseenter", onEnter);
            item.removeEventListener("mousemove", onMove);
            item.removeEventListener("mouseleave", onLeave);
        });
      });

      // Reset layout when leaving the whole container
      const onContainerLeave = () => {
        gsap.to(items, { flexGrow: 1, filter: "grayscale(0%) brightness(100%)", rotationY: 0, rotationX: 0, duration: 0.5, ease: "power2.out" });
      };
      
      const containerEl = containerRef.current;
      if (containerEl) {
        containerEl.addEventListener("mouseleave", onContainerLeave);
      }

    return () => {
        cleanupListeners.forEach(c => c());
        if (containerEl) containerEl.removeEventListener("mouseleave", onContainerLeave);
    };
  }, [sectionContent]); // Re-run if sectionContent loads and renders the items

  return (
    <div 
      className="discover_list accordion-container" 
      ref={containerRef} 
      style={{ 
        display: 'flex', 
        flexDirection: width < 768 ? 'column' : 'row', 
        alignItems: 'stretch', 
        gap: '15px', 
        width: '100%', 
        height: width < 768 ? 'auto' : '600px', 
        marginBottom: '100px', 
        padding: '0 20px', 
        boxSizing: 'border-box' 
      }}
    >

      {!sectionContent ? (
        <>
          {" "}
          <Skeleton.Avatar active={true} shape={"square"} />
        </>
      ) : (
        <>
          <div
            className="dicover_card accordion-item"
            style={{
              flexBasis: width < 768 ? "auto" : 0,
              flexGrow: 1, 
              minWidth: 0,
              width: width < 768 ? "100%" : "auto",
              height: width < 768 ? "300px" : "auto",
              overflow: "hidden",
              borderRadius: "16px",
              backgroundSize: "cover",
              backgroundPosition: "center",
              cursor: "pointer",
              position: "relative",
              boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              /*      backgroundImage: `linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.25)), url(${
            user && user.fabric_type !== "knit" ? Garments : knit_garment
          })`, */
              backgroundImage: ` url(${
                process.env.REACT_APP_STORAGE_URL + sectionContent?.image_1
              })`,
            }}
          >
            {garmentsRes && (
              <DiscoverItem
                data={garmentsRes}
                garment
                name={sectionContent?.title_1}
              />
            )}
          </div>
        </>
      )}
      {!sectionContent ? (
        <>
          {" "}
          <Skeleton.Avatar active={true} shape={"square"} />
        </>
      ) : (
        <>
          <div
            className="dicover_card accordion-item"
            style={{
              flexBasis: width < 768 ? "auto" : 0,
              flexGrow: 1, 
              minWidth: 0,
              width: width < 768 ? "100%" : "auto",
              height: width < 768 ? "300px" : "auto",
              overflow: "hidden",
              borderRadius: "16px",
              backgroundSize: "cover",
              backgroundPosition: "center",
              cursor: "pointer",
              position: "relative",
              boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              /*           backgroundImage: `linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.25)), url(${knit_special_collections})`,
               */ backgroundImage: ` url(${
                process.env.REACT_APP_STORAGE_URL + sectionContent?.image_2
              })`,
            }}
          >
            {collectionRes && (
              <DiscoverItem
                data={collectionRes.filter((k: any) => !k.collection_id)}
                name={sectionContent?.title_2}
              />
            )}
          </div>
        </>
      )}

      {/*      <div
        className="dicover_card"
        style={{
          backgroundPosition:
            user && user.fabric_type !== "knit" ? "center" : "30%",
          backgroundImage: `linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.25)), url(${
            user && user.fabric_type !== "knit"
              ? SpecialCollection
              : knit_special_collections
          })`,
        }}
      >
        {specialCollectionsRes && <DiscoverItem data={specialCollectionsRes} />}
      </div> */}
      {!sectionContent ? (
        <>
          {" "}
          <Skeleton.Avatar active={true} shape={"square"} />
        </>
      ) : (
        <>
          <div
            className="dicover_card accordion-item"
            style={{
              flexBasis: width < 768 ? "auto" : 0,
              flexGrow: 1, 
              minWidth: 0,
              width: width < 768 ? "100%" : "auto",
              height: width < 768 ? "300px" : "auto",
              overflow: "hidden",
              borderRadius: "16px",
              backgroundSize: "cover",
              backgroundPosition: "center",
              cursor: "pointer",
              position: "relative",
              boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              /*           backgroundImage: `linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.25)), url(${seasons})`,
               */
              backgroundImage: ` url(${
                process.env.REACT_APP_STORAGE_URL + sectionContent?.image_3
              })`,
            }}
          >
            {seasonCollectionRes && (
              <DiscoverItem
                data={seasonCollectionRes}
                name={sectionContent?.title_3}
              />
            )}
          </div>
        </>
      )}
      {/*    <div
        className="dicover_card"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.25)), url(${discoverData[1].img})`,
          backgroundPosition: "center",
        }}
      >
        {responsibleChoices && (
          <DiscoverItem data={responsibleChoices} name="Responsible Choices" />
        )}
      </div> */}
      {!sectionContent ? (
        <>
          {" "}
          <Skeleton.Avatar active={true} shape={"square"} />
        </>
      ) : (
        <>
          <div className="accordion-item" style={{ 
            flexBasis: width < 768 ? "auto" : 0, 
            flexGrow: 1, 
            minWidth: 0, 
            width: width < 768 ? "100%" : "auto", 
            height: width < 768 ? "300px" : "auto", 
            borderRadius: "16px", 
            overflow: "hidden", 
            cursor: "pointer", 
            position: "relative", 
            boxShadow: "0 10px 30px rgba(0,0,0,0.1)" 
          }}>
             <DiscoverCard
            title={sectionContent?.title_4}
            submenu={responsibleChoices}
            image={process.env.REACT_APP_STORAGE_URL + sectionContent?.image_4}
          />
          </div>
        </>
      )}
    </div>
  );
};
